import { login } from "./login/UserLogin";

export const fetchWithHandling = async (url, loginRedirect ,options = {}) => {
    const response = await fetch(url, {
        credentials: "include",
        ...options,
        headers: {
            "Content-Type": "application/json",
            
        }
    });

    if (!response.ok) {
        if (response.status === 401) {
            login(loginRedirect);
        }

        const errorText = await response.text();
        throw new Error(`Request failed: ${response.status} - ${errorText}`);
    }

    const contentType = response.headers.get("content-type");
    if (contentType?.includes("application/json")) {
        return await response.json();
    }

    return await response.text();
};

export const fetchWithHandlingNoParse = async (url, loginRedirect ,options = {}) => {
    const response = await fetch(url, {
        credentials: "include",
        ...options,
        headers: {
            "Content-Type": "application/json",
            
        }
    });

    if (!response.ok) {
        if (response.status === 401) {
            login(loginRedirect);
        }

        const errorText = await response.text();
        throw new Error(`Request failed: ${response.status} - ${errorText}`);
    }

    return response;
};
